import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ConsultNoteQueueResult } from '../../../core/models/consult-note-lists/consult-note-queue-result.model';
import { NgClass, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { UserPresenceComponent } from '../user-presence/user-presence.component';
import { PhoneNumberComponent } from '../phone-number/phone-number.component';
import { ConsultNoteOfficeComponent } from '../consult-note-office/consult-note-office.component';
import { PatientNameComponent } from '../patient-name/patient-name.component';
import { ConsultNoteEstimatedValuesComponent } from '../consult-note-estimated-values/consult-note-estimated-values.component';
import { PatientAttachmentStatusPipe } from 'app/shared/pipes/patient-attachment-status.pipe';

@Component({
    selector: 'app-consult-note-queue-results',
    templateUrl: './consult-note-queue-results.component.html',
    styleUrls: ['./consult-note-queue-results.component.scss'],
    imports: [NgClass,
              RouterLink,
              UserPresenceComponent,
              PhoneNumberComponent,
              ConsultNoteOfficeComponent,
              PatientNameComponent,
              ConsultNoteEstimatedValuesComponent,
              DatePipe,
              PatientAttachmentStatusPipe]
})
export class ConsultNoteQueueResultsComponent {
  @Input() consultNoteQueueResults: ConsultNoteQueueResult[] = [];
  @Input() selectedConsultNoteIds: number[] = [];
  @Input() canAssignUser = false;
  @Input() myWorkQueue = false;

  @Output() selectionChanged = new EventEmitter<ConsultNoteQueueResult>();

  constructor() {}

  public isSelected(consultNote): boolean {
    return this.selectedConsultNoteIds.includes(consultNote.id);
  }

  public handleConsultNoteSelection(consultNote: ConsultNoteQueueResult) {
    this.selectionChanged.emit(consultNote);
  }
}
